import React from "react";

const ArrowUpIcon = (props: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>arrow-up-1-icon</title>
      <path
        d="M8 3c.4 0 .778.158 1.06.443l6.648 6.833c.39.395.39 1.033 0 1.428s-1.024.395-1.414 0L8 5.228l-6.293 6.476c-.39.395-1.023.395-1.414 0-.39-.395-.39-1.033 0-1.428L6.94 3.443C7.222 3.158 7.597 3 8 3z"
        fill="#fff"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default ArrowUpIcon;
